import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="relative hidden bg-slate-900 lg:block">
        <img src="/hero.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="relative flex h-full flex-col justify-between p-12">
          <Brand light />
          <div>
            <h2 className="font-heading text-4xl font-bold leading-tight tracking-tight text-white">Gestione informative<br />condominiali.</h2>
            <p className="mt-4 max-w-sm text-slate-300">Inserisci i condomini, attiva i documenti e personalizza i modelli in un unico pannello.</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center bg-slate-50 px-6">
        <form onSubmit={submit} className="fade-up w-full max-w-sm space-y-6" data-testid="admin-login-form">
          <div className="lg:hidden"><Brand /></div>
          <div>
            <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Area riservata</h1>
            <p className="mt-1 text-sm text-slate-500">Accedi per gestire i condomini.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email-input" className="h-11 bg-white" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password-input" className="h-11 bg-white" />
          </div>
          {error && <p data-testid="admin-login-error" className="rounded-md bg-red-50 p-3 text-sm text-red-700">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit-button" className="inline-flex h-11 w-full items-center justify-center gap-2 rounded-md bg-slate-900 font-medium text-white transition-colors hover:bg-blue-600 disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Accedi
          </button>
        </form>
      </div>
    </div>
  );
}
